import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import styles from './styles.module.scss';

const LeftFieldLogo = ({ color, active }) => {
  const className = classNames({
    icon: true,
    'icon-vertical-leftfield': true,
    [styles.logo]: true,
    [styles[color]]: true,
    [styles.active]: active,
  });

  return (
    <div className={styles.container}>
      <span className={className} />
    </div>
  );
};

LeftFieldLogo.propTypes = {
  color: PropTypes.string.isRequired,
  active: PropTypes.bool,
};

LeftFieldLogo.defaultProps = {
  active: false,
};

export default LeftFieldLogo;
